function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
  fill: "#B2A1FB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M49 113H74.1245C81.362 113 87.7379 114.564 93.2522 117.693C98.8354 120.752 103.109 125.062 106.073 130.624C109.106 136.117 110.622 142.409 110.622 149.5C110.622 156.591 109.106 162.918 106.073 168.48C103.109 173.972 98.8354 178.283 93.2522 181.411C87.7379 184.47 81.362 186 74.1245 186H49L49 113ZM74.1245 172.964C80.6727 172.964 85.739 170.844 89.3233 166.603C92.9765 162.292 94.8031 156.591 94.8031 149.5C94.8031 142.409 92.9765 136.742 89.3233 132.501C85.739 128.191 80.6727 126.036 74.1245 126.036H64.5089L64.5089 172.964H74.1245Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M120.184 113L168.778 113V126.453L135.693 126.453V142.826H162.575V155.653L135.693 155.653V172.547L169.916 172.547V186L120.184 186L120.184 113Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M179.251 113H227.018V126.453H194.76V143.556H221.228V156.383H194.76L194.76 186H179.251L179.251 113Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M235.491 113H251L251 186H235.491L235.491 113Z",
  fill: "white"
});

var SvgDefi = function SvgDefi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDefi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DEFI.c35c8e98.svg";
export { ForwardRef as ReactComponent };